<template>
  <div class="row mb-4 mb-4">
    <div class="col-12 col-md-8 text-primary">
      <h5>{{ title }}</h5>
    </div>
    <div class="col-12 col-md-4" v-if="!disabled">
      <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
        <button
          type="button"
          class="btn btn-primary btn-with-shadow"
          data-toggle="modal"
          @click="openAddEditModal"
        >
          Añadir
        </button>
      </div>
    </div>

    <p class="col-12 mt-4" v-if="['OINSP'].includes(this.activity)">
      Indicar el producto, proceso, servicio y/o instalaciones, los
      procedimientos aplicables del organismo, el documento normativo de
      referencia para la declaración de la conformidad.
    </p>

    <div class="col-12 mt-4">
      <app-table :id="tableId" :options="options" @action="getListAction" />

      <scopes-modal
        v-if="isAddEditModalActive"
        modalTitle="Añadir Alcance"
        editModalTitle="Editar Alcance"
        :table-id="tableId"
        :selected-url="selectedUrl"
        @close-modal="closeAddEditModal"
        :activity="activity"
      />

      <app-confirmation-modal
        v-if="deleteConfirmationModalActive"
        modal-id="modal-delete"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="Confirmación"
        message="¿Desea eliminar este registro?"
      />
    </div>

    <div class="col-12 mt-4" v-if="['OINSP'].includes(this.activity)">
      <p class="my-4 text-center font-weight-bold">
        INSTRUCCIONES PARA LA DEFINICIÓN DEL ALCANCE DE ACREDITACIÓN, EN
        ORGANISMOS DE INSPECCIÓN
      </p>

      <p>
        <b>Nota (1):</b> Los sectores de inspección están categorizados de la
        siguiente manera: agroalimentario, industrial, hidrocarburos, servicios,
        ambiental, automotriz, agrícola, sanitario.
      </p>

      <p>
        <b>Nota (2):</b> Los campos de inspección/alcance es el nombre de la
        actividad de inspección que realiza el OI. Ej. Inspección técnica de
        tanques verticales.
      </p>

      <p>
        <b>Nota (3):</b> Corresponde a: diseño de un producto, producto,
        servicio, proceso o servicio que se inspecciona. Ej., cacao, plantas
        procesadora de bebidas alcohólicas.
      </p>

      <p>
        <b>Nota (4):</b> El tipo de inspección o metodología que se aplica en la
        activdad de inspección y corresponde a: visual, Instrumental,
        documental, etc.
      </p>

      <p>
        <b>Nota (5):</b> Los OEC en relación a su independencia pueden
        clasificarse en: Tipo A (de tercera parte), Tipo B (primera y/o segunda
        parte separada de parte involucrada que presta servicios de inspección
        únicamente a su organización matriz; un OI interno a una organización),
        Tipo C (primera y/o segunda parte, no necesariamente separada de parte
        involucrada que presta servicios de inspección a su organización matriz
        y/o a otras partes).
      </p>

      <p>
        <b>Nota (6):</b> Incluir todos los procedimientos que se utilicen
        directamente en el proceso de inspección, si procede, referenciar a los
        procedimientos relativos a la toma de muestra, plan de muestreo, entre
        otros.
      </p>

      <p>
        <b>Nota (7):</b> Documentos frente a los que se declara conformidad
        (incluir referencia a la norma, especificación, código, reglamentos,
        etc. Respecto a la vigencia de los documentos colocar año de
        publicación, reafirmación, edición/revisión (cuando aplique) su fecha de
        vigencia o número de revisión.
      </p>

      <p>Ejemplo:</p>

      <p>
        API MPMS Chapter 3.1 A:2013 (R2018), Ed. 3, Standard Practice for the
        Manual Gauging of Petroleum and Petroleum Products
      </p>

      <p>
        En ausencia de éstos hágase referencia al documento utilizado incluyendo
        revisión y fecha. Cuando la inspección se realiza, según un
        procedimiento no normalizado, se debe indicar el procedimiento o
        instructivo desarrollado. El alcance de la acreditación se refiere
        EXCLUSIVAMENTE a las inspecciones desarrolladas por los procedimientos
        citados, no a todas las posibles de los documentos normativos
        relacionados.
      </p>
    </div>
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  props: {
    activity: String,
    title: String,
    disabled: Boolean,
    status: String,
  },
  data() {
    return {
      tableId: "scopes-table",
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      rowData: {},
      options: {
        url: `request?accAppId=${this.$store.state.accreditation.id}&initial=1`,
        name: "",
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "scopes-modal",
            modalId: "add-edit-modal",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "delete",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    // this.options.columns = [...this.tableColumns, this.actionObj];
    let columns = [];
    if (["OCPR"].includes(this.activity)) columns = this.OCPR;
    else if (["CSGAS"].includes(this.activity)) columns = this.CSGAS;
    else if (["OCSG", "CSA"].includes(this.activity)) columns = this.OCSG;
    else if (["CSIA"].includes(this.activity)) columns = this.CSIA;
    else if (["OCPE"].includes(this.activity)) columns = this.OCPE;
    else if (["OINSP"].includes(this.activity)) columns = this.OINSP;
    else if (["OENY", "OICC"].includes(this.activity)) columns = this.OENY;
    else if (["OCLN"].includes(this.activity)) columns = this.OCLN;
    else if (["OEYC"].includes(this.activity)) columns = this.OEYC;
    else if (["OEAP"].includes(this.activity)) columns = this.OEAP;

    this.options.columns = [...columns, this.disabled ? [] : this.actionObj];
  },
  methods: {
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },

    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("delete")) {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `request/${rowData.id}`;
        this.openAddEditModal();
      }
    },

    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    confirmed() {
      let url = `request/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#delete").modal("hide");
          this.cancelled();
          this.$toastr.s(this.$t("deleted_success"));
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
  },
};
</script>